import { Icon } from "@fortawesome/fontawesome-svg-core";
import { faEyeSlash, faLink } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppSelector } from "hooks/hook";
import { useStocks } from "hooks/useStocks";
import { filter, find } from "lodash";
import moment from "moment";
import "rc-tree-select/assets/index.css";
import { useState } from "react";
import { shallowEqual, useDispatch } from "react-redux";
import { Button, Spinner } from "reactstrap";
import { getDateFromNow } from "resbutler-utils/utils";
import { toggleSetting } from "store/reducers/settingsSlice";
import { ProgressType } from "../../components/Layout/OmsSelector";
import { useHiddenDockets } from "../../hooks/useHiddenDockets";
import { setLinkedTable } from "../../store/reducers/rootSlice";
import MenuItemModal from "./MenuItemModal";
import TableLinkModal from "./TableLinkModal";

const style: any = {
  button: { position: "relative", whiteSpace: "nowrap" },
  buttonCount: {
    position: "absolute",
    top: "-8px",
    right: "-8px",
    borderRadius: "0.625rem",
    backgroundColor: "#f05050",
    color: "#fff",
    padding: "0.1875rem 0.4375rem",
    fontSize: "0.75rem",
    zIndex: 9,
  },
};

function MenuItemsPopUp({ restaurantId, date }: { restaurantId: string; date: string }) {
  const dispatch = useDispatch();
  const { hiddenDocketCount } = useHiddenDockets();

  const { linkedTable, dockets, showHiddenDockets, progress, restaurants } = useAppSelector((state) => {
    return {
      linkedTable: state.root.linkedTable,
      dockets: state.root.dockets,
      showHiddenDockets: state.settings.showHiddenDockets,
      progress: state.root.progress,
      restaurants: state.root.restaurants,
    };
  }, shallowEqual);

  const [showMenuItemModal, setShowMenuItemModal] = useState(false);

  const { loading, data } = useStocks(Number(date), restaurantId);
  const overrideCount = filter(data.products, (p) => find(p.sizes, (s) => s.enabled) !== undefined).length + filter(data.specials, (p) => find(p.sizes, (s) => s.enabled) !== undefined).length;

  const now = moment.unix(Date.now() / 1000).tz(restaurants?.[restaurantId]?.zoneId);
  const currentDate = getDateFromNow(now);

  const tableNumbers = Array.from(new Set(dockets.map((d) => d.tableNo).filter((x) => !!x))).sort();

  const [showTableLinkModal, setShowTableLinkModal] = useState(false);

  const handleTableOnClick = (tableNumber, isActive) => {
    dispatch(setLinkedTable(isActive ? null : tableNumber));
    setShowTableLinkModal(false);
  };

  const onToggleHiddenDockets = () => {
    dispatch(toggleSetting("showHiddenDockets"));
  };

  return (
    <>
      <div className="d-flex gap-2">
        <Button className="flex-grow-1" type="button" style={style.button} onClick={(e) => setShowMenuItemModal(!showMenuItemModal)} disabled={loading}>
          {loading ? "Initializing data..." : "Menu Control"}
          <span className="badge" style={style.buttonCount}>
            {overrideCount > 0 ? overrideCount : ""}
          </span>
        </Button>
        <Button className="flex-grow-1" type="button" color={linkedTable ? "danger" : "secondary"} style={style.button} onClick={() => setShowTableLinkModal(!showTableLinkModal)} disabled={loading}>
          {loading ? (
            <Spinner size={"sm"}>{""}</Spinner>
          ) : (
            <>
              Table Link <FontAwesomeIcon icon={faLink as Icon} />
            </>
          )}
        </Button>
        <Button type="button" color={showHiddenDockets ? "danger" : "secondary"} style={{ ...style.button, width: 50 }} disabled={loading || [ProgressType.Completed].includes(progress)} onClick={onToggleHiddenDockets}>
          {loading ? (
            <Spinner size={"sm"}>{""}</Spinner>
          ) : (
            <>
              <FontAwesomeIcon icon={faEyeSlash as Icon} />
              {!!hiddenDocketCount && (
                <span className="badge badge-danger" style={style.buttonCount}>
                  {hiddenDocketCount}
                </span>
              )}
            </>
          )}
        </Button>
      </div>
      {showMenuItemModal && !loading && <MenuItemModal setShowModal={setShowMenuItemModal} restaurantId={restaurantId} date={date} currentDate={currentDate} />}
      {showTableLinkModal && <TableLinkModal tableNumbers={tableNumbers} setShowModal={setShowTableLinkModal} linkedTable={linkedTable} handleTableOnClick={handleTableOnClick} />}
    </>
  );
}

// https://reactjs.org/docs/react-api.html#reactmemo
export default MenuItemsPopUp;
